<template>
  <div
    :class="[
      'navigation',
      {
        opened: menuOpened,
        white: menuOpened || mobile || scrolledDown,
        menuOpened: menuOpened
      }
    ]"
    id="navigation"
    ref="navigation"
  >
    <div class="container">
      <nav>
        <div class="logo-wrap">
          <div class="logo">
            <a href="#splash-anchor">
              <img
                src="../assets/logo_white.svg"
                alt="Betonarna sava logotip"
                class="logo-white"
              />
              <img
                src="../assets/logo_color.svg"
                alt="Betonarna sava logotip"
                class="logo-color"
              />
            </a>
          </div>
          <div class="contact-details">
            <div class="email">
              <span class="icon envelope"></span>
              <a href="mailto:info@betonarna-sava.si">info@betonarna-sava.si</a>
            </div>
            <div class="tel">
              <span class="icon telephone"></span>
              <a href="tel:0805060">080 50 60</a>
            </div>
            <div class="loc">
              <span class="icon pin"></span>
              <a href="#kontakt-anchor">Hrušica, Jesenice</a>
            </div>
          </div>
        </div>
        <div class="links">
          <ul>
            <li v-for="link in links" v-bind:key="link.href">
              <a :href="link.href" :target="link.target">
                <span v-if="link.icon" :class="[link.icon, 'icon']"> </span>
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>

        <div
          class="hamburger hamburger--collapse"
          v-bind:class="{ 'is-active': menuOpened }"
          v-on:click="hamburgerClick"
        >
          <div class="hamburger-box">
            <div class="hamburger-inner"></div>
          </div>
        </div>

        <div class="mobile-dropdown" ref="dropdown">
          <div class="mobile-links">
            <ul>
              <li v-for="link in links" v-bind:key="link.href">
                <a
                  :href="link.href"
                  v-on:click="closeMenu"
                  :target="link.target"
                >
                  <span v-if="link.icon" :class="link.icon"></span>
                  {{ link.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuOpened: false,
      scrolledDown: false,
      mobile: window.innerWidth < 600,
      links: [
        {
          label: "storitve",
          href: "#storitve-anchor"
        },
        {
          label: "strojni park",
          href: "#strojni-park-anchor"
        },
        {
          label: "reference",
          href: "#reference-anchor"
        },
        {
          label: "kontakt",
          href: "#kontakt-anchor"
        },
        {
          label: "cenik",
          href: `/static/pdf/cenik_betonov_in_agregatov.pdf?v=${Date.now()}`,
          target: "_blank",
          icon: "pdf"
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    hamburgerClick() {
      if (this.menuOpened) {
        this.closeMenu();
      } else {
        TweenMax.to(this.$refs.dropdown, 0.6, {
          height: 256,
          display: "block"
        });
        this.menuOpened = true;
      }
    },

    closeMenu() {
      TweenMax.to(this.$refs.dropdown, 0.6, {
        height: 0,
        onComplete: () => {
          this.$refs.dropdown.style.display = "none";
        }
      });
      this.menuOpened = false;
    },

    handleScroll() {
      if (window.scrollY > 100) {
        this.scrolledDown = true;
      } else {
        this.scrolledDown = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue